import { Flex } from "@chakra-ui/react"
import CrfErrorBoundary from "components/error/CrfErrorBoundary"
import SeoMetaFields from "components/header/seoMetaFields"
import PageContent from "components/layout/pageContent"
import Header from "./headerTct2026"
import Footer from "./footerTct2026"
import FloatingChatbot from "components/ai/FloatingChatbot"

// import Ad from "components/matrix/ad"

export default function LayoutTct2026(props) {
    // pull and remove the first item out of the props.matrix array
    // so it can be inserted into the header as the page top content
    let [pageTopContent, ...contentBlocks] = props.matrix || []
    // default page top content if none is provided
    if (!pageTopContent) {
        pageTopContent = {
            type: "body",
            body: props.page?.title ? `<h1>${props.page?.title}</h1>` : "",
            backgroundImage: [
                {
                    url: "https://assets.crfconnect.com/meetings/tct2026/pages/test-page/gradient_mwc26.jpg",
                },
            ],
        }
    }

    return (
        <LayoutWrapper {...props} pageTopContent={pageTopContent}>
            <CrfErrorBoundary>
                <PageContent
                    page={props.page}
                    matrix={contentBlocks}
                    site={props.site}
                    user={props.user}
                    colorMode={props.colorMode}
                    channels={props.channels}
                    sessionTypes={props.sessionTypes}
                    sessionId={props.sessionId}
                    presentationId={props.presentationId}
                    facetsConfig={props.facetsConfig}
                    craftSiteId={props.craftSiteId}
                    showPageHeader={false}
                >
                    {props.children}
                </PageContent>
            </CrfErrorBoundary>
        </LayoutWrapper>
    )
}

function LayoutWrapper({ children, ...props }) {
    const bg = props.bg || "#fff"
    const pageTitle = props.page?.showPageHeader ? props.page.title : ""

    return (
        <Flex
            direction="column"
            minHeight="100vh"
            bg={bg}
            className={props.className + " " + (props.layoutVariant === "app" ? " layout--app" : "")}
            {...props.bgStyles}
        >
            <SeoMetaFields page={props.page} />
            <Header
                site={props.site}
                pageTitle={pageTitle}
                pageTopContent={props.pageTopContent}
                hideNav={props.hideNav}
            />

            <Flex className="pageBody" flexGrow={1} direction="column">
                {/*{!props.hideAd && resolvedAd ? (*/}
                {/*    <Ad block={{ adUnit: resolvedAd }} mt={0} pb={0} bg="transparent" />*/}
                {/*) : null}*/}
                {children}
            </Flex>

            <FloatingChatbot site={props.site} />

            <Footer socialFooterText={props.socialFooterText} />
        </Flex>
    )
}
